<template>
  <div class="grid grid-cols-6 gap-6">
    <div
      v-for="(category) in list"
      :key="category?.id"
      class="bg-white rounded-3xl p-4 flex flex-col gap-4 items-center shadow-md cursor-pointer relative overflow-hidden"
      @click="onClickingCategory(category)">
      <img
        class="w-full h-40 rounded-2xl overflow-hidden"
        :class="{ 'gray-scale': !category?.enabled }"
        :src="category?.imageURI" />

      <div
        class="absolute text-xs bg-gray-600 text-white w-full text-center rotate-45"
        :class="{'none': category?.enabled}">Disabled</div>

      <h3>{{ category?.name }}</h3>

      <div class="flex gap-4">
        <button
          title="Edit"
          class="text-gray-600 hover:text-white bg-gray-50 hover:bg-gray-600 rounded-full transition-colors flex items-center justify-center w-9 h-9 shadow-md border-none cursor-pointer" @click.stop="onClickingEdit(category?.id)">
          <i class="far fa-edit"></i>
        </button>
        <button
          title="Delete"
          class="text-red-600 hover:text-white bg-red-50 hover:bg-red-600 rounded-full transition-colors flex items-center justify-center w-9 h-9 shadow-md border-none cursor-pointer"
          @click.stop="onDeleteClicked(category?.id)">
          <i aria-hidden="true" class="fa fa-trash"></i>
        </button>
        <button
          :title="category?.enabled ? 'Disable' : 'Enable'"
          class="text-blue-600 hover:text-white bg-blue-50 hover:bg-blue-600 rounded-full transition-colors flex items-center justify-center w-9 h-9 shadow-md border-none cursor-pointer"
          @click.stop="onToggleClicked(category)">
          <i :class="{'fa fa-low-vision': category?.enabled, 'fas fa-eye': !category?.enabled}"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { translations } from '@/mixins';

export default {
  name: 'CategoriesGrid',

  mixins: [translations],

  props: {
    list: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onToggleClicked (category) {
      this.$emit('enableDisableCategory', category);
    },
    onDeleteClicked (categoryId) {
      this.$emit('onDeleteClicked', categoryId);
    },
    onClickingCategory (item) {
      this.$router.push({ name: 'category details', params: { categoryId: item?.id } });
    },
    onClickingEdit (categoryId) {
      this.$router.push({
        name: 'category details',
        params: { categoryId: categoryId },
        query: { tab: 'update_category' },
      });
    },
  },
};
</script>

<style scoped>
  .rotate-45 {
    transform: rotate(45deg);
    right: -35%;
  }
  .none {
    display: none;
  }
  .gray-scale {
    filter: grayscale(100%);
  }
</style>
